import { MARQUEE_ITEMS } from "../data";
import { Zap } from "lucide-react";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="marquee" className="relative border-y border-white/10 bg-gradient-to-r from-[#0a0a14] via-[#0B111E] to-[#0a0a14] py-5 overflow-hidden">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((item, i) => (
          <div key={i} className="flex items-center gap-4 px-8">
            <Zap className="h-4 w-4 text-[#60A5FA]" fill="currentColor" />
            <span className="font-heading text-sm font-extrabold uppercase tracking-[0.25em] text-gray-200">
              {item}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
